// extracted by mini-css-extract-plugin
export default {"statusPill":"view-details_statusPill__MJFGJ","statusDot":"view-details_statusDot__zZMZY","nameContainer":"view-details_nameContainer__4ZgMq"};